import { jsxs, jsx, Fragment } from 'react/jsx-runtime';
import * as React from 'react';
import '../../utils/index_orig/index.esm.js';
import '../../utils/theme/theme-provider/index.esm.js';
import styles from '../../styles/uitk-egds-badge.css';
import { EGDSBadgeNotificationThemes } from '../types/index.esm.js';
import { classNames } from '../../utils/classnames/index.esm.js';
import { validatePropType } from '../../utils/validate-prop-types/index.esm.js';
const getClassNameList = classNames.bind(styles);
const EGDSBadgeNotification = props => {
  const {
    count,
    theme,
    visible,
    a11yText,
    className,
    children
  } = props;
  const baseCssClassName = 'uitk-badge';
  const notificationCssClassName = 'uitk-badge-notification';
  const hasCount = typeof count === 'string';
  let withIcon = false;
  React.Children.forEach(children, child => {
    if (child.type?.displayName?.match(/(EGDS|Uitk)Icon/)) {
      withIcon = true;
    }
  });
  const standardBadgeClassNames = getClassNameList(baseCssClassName, hasCount ? `${notificationCssClassName}-count` : `${notificationCssClassName}-dot`, withIcon ? `${notificationCssClassName}-with-icon` : `${notificationCssClassName}-with-text`, `${notificationCssClassName}-${validatePropType(theme, EGDSBadgeNotificationThemes) ? theme : EGDSBadgeNotificationThemes.DEFAULT}`, className);
  return visible ? jsxs("span", {
    className: getClassNameList(`${notificationCssClassName}-wrapper`),
    children: [withIcon ? jsx("span", {
      className: getClassNameList(`${notificationCssClassName}-${hasCount ? 'count-mask' : 'dot-mask'}`),
      children: children
    }) : jsx(Fragment, {
      children: children
    }), jsxs("span", {
      className: standardBadgeClassNames,
      "aria-hidden": !!a11yText,
      children: [hasCount && jsx("span", {
        className: getClassNameList(`${notificationCssClassName}-numbers`),
        children: Number(count) > 99 ? '99+' : count
      }), a11yText && jsx("span", {
        className: getClassNameList('is-visually-hidden'),
        children: a11yText
      })]
    })]
  }) : jsx(Fragment, {
    children: children
  });
};
EGDSBadgeNotification.displayName = 'EGDSBadgeNotification';
export { EGDSBadgeNotification };